export default __webpack_public_path__ + "static/media/ic_en_flag.ce9a6bf8.svg";